import {
  Tag,
  Icon,
  Tree,
  Menu,
  Modal,
  Input,
  Button,
  message,
  Dropdown,
  Popconfirm,
} from "antd";
import React from "react";
import moment from "moment";
import classNames from "classnames";
import { connect } from "react-redux";

import {
  uuid,
  isWeb,
  unique,
  byteSubstring,
  formatDateRange,
} from "../../../../util/index";
import Info from "../../../Detail/Info";
import WatermarksV2 from "./watermark.js";
import Uploader from "../../../Common/Uploader";
import ajaxUtil from "../../../../util/ajax.js";
import GuideTip from "../../../Common/GuideTip";
import AjaxAction from "../../../../actions/AjaxAction.js";
import { getPhotoSrc, style } from "../../../../util/image";

import "./index.scss";

const { DOMAIN_CURRENT, ajaxv2, ajax } = ajaxUtil;
const { TreeNode } = Tree;
const HORIZONTAL_HEIGHT = isWeb() ? 347 : 194;

let preTitle; //当前的document.title
const currentShowTitle = `编辑相册-即享CRM`;

export const ALIGN_MAP = [
  { name: "左上", key: "nw", top: 0, left: 0 },
  { name: "正上", key: "north", top: 0, left: "50%" },
  { name: "右上", key: "ne", top: 0, right: 0 },
  { name: "正左", key: "west", left: 0, top: "50%" },
  { name: "正右", key: "east", right: 0, top: "50%" },
  { name: "左下", key: "sw", bottom: 0, left: 0 },
  { name: "正下", key: "south", bottom: 0, left: "50%" },
  { name: "右下", key: "se", right: 0, bottom: 0 },
  { name: "正中", key: "center", top: "50%", left: "50%" },
];

export class Watermarks extends React.Component {
  static defaultProps = {
    useLabel: true,
    defaultStyle: "wx_750_n",
    useReset: true,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  changeWatermark = (key, val) => {
    let { edit } = this.state;
    if (key == "icon") {
      val = val.uploadParam.key;
    }
    edit[key] = val;
    this.setState({
      edit,
    });
  };

  deleteWatermark = (item) => {
    let { watermarks } = this.props;
    watermarks = watermarks
      .map((it) => {
        if (it.id == item.id) {
          return null;
        }
        return it;
      })
      .filter(Boolean);

    this.onWatermarkChange(watermarks);
  };

  onWatermarkChange = (result) => {
    this.props.onChange(result);
  };

  onEditWatermark = () => {
    let { watermarks } = this.props;
    let { edit } = this.state;

    !watermarks && (watermarks = []);

    if (!edit.align) {
      message.warning("请选择水印位置");
      // watermarks = watermarks.map(it=>{
      //     if(it.id == edit.id) {
      //         return null;
      //     }
      //     return it;
      // }).filter(Boolean);
    } else if (!edit.icon) {
      message.warning("请上传水印图片");
      // watermarks = watermarks.map(it=>{
      //     if(it.id == edit.id) {
      //         return null;
      //     }
      //     return it;
      // }).filter(Boolean);
    } else {
      if (edit.id) {
        watermarks = watermarks.map((it) => {
          if (it.id == edit.id) {
            return edit;
          }
          return it;
        });
      } else {
        watermarks.push({
          id: uuid(),
          ...edit,
        });
      }
    }

    this.setState(
      {
        edit: null,
      },
      () => {
        this.onWatermarkChange(watermarks);
      }
    );
  };

  insertWatermark = () => {
    let { watermarks } = this.props;

    !watermarks && (watermarks = []);

    let item = {
      align: "se",
      noborder: 1,
      percent: 20,
      icon: "",
      opacity: 100,
    };
    let index = watermarks.length;
    // this.onWatermarkChange(watermarks);

    this.setState({
      // watermarks,
      edit: item,
    });
  };

  calMarkStyle = (mark) => {
    let style = {
      position: "absolute",
    };
    if (mark.align) {
      let align = Object.assign(
        {},
        ALIGN_MAP.find((it) => it.key == mark.align)
      );
      delete align.key;
      delete align.name;

      style = {
        ...style,
        ...align,
      };
    }

    if (mark.percent) {
      // style.height = Math.round(mark.percent * 1 / 100 * HORIZONTAL_HEIGHT) + 'px';
      style.width = `${mark.percent}%`;
    }
    if (!mark.noborder) {
      if (typeof style.top != "undefined") {
        style.marginTop = 4;
      }
      if (typeof style.bottom != "undefined") {
        style.marginBottom = 4;
      }
      if (typeof style.left != "undefined") {
        style.marginLeft = 4;
      }
      if (typeof style.right != "undefined") {
        style.marginRight = 4;
      }
    }

    if (style.top == "50%") {
      style.marginTop =
        style.marginTop * 1 -
        Math.round(((mark.percent * 1) / 100) * HORIZONTAL_HEIGHT) +
        "px";
    }
    if (style.left == "50%") {
      style.marginLeft = style.marginLeft * 1 + "px";
    }

    return style;
  };

  showBigPic = () => {
    let { watermarks } = this.props;
    let url = style(
      "source/190729/c0f61aed21dbda48c5efe1b61733f3c9.jpg",
      "wx_750_n",
      {
        watermark:
          watermarks && watermarks.length
            ? watermarks.filter((it) => !!it.icon)
            : undefined,
      }
    );

    window.open(url, "watermark_preview");
  };

  render() {
    let { watermarks, useLabel, defaultStyle, useReset } = this.props;
    let { edit } = this.state;
    const wrapperCls = classNames("flex1", isWeb() ? "dp-f" : "");
    return (
      <div className="dp-f j-c a-c">
        <div
          className={wrapperCls}
          style={{ marginRight: "20px", marginBottom: "10px" }}
        >
          {useLabel ? <div className="label">水印设置</div> : null}
          <div className="value flex1">
            <div>
              <div className="flex1 watermarks-container dp-f">
                <div className="watermarks-container-preview horizontal">
                  <img
                    className=""
                    src={style(
                      "source/190729/c0f61aed21dbda48c5efe1b61733f3c9.jpg",
                      defaultStyle,
                      {
                        watermark:
                          watermarks && watermarks.length
                            ? watermarks.filter((it) => !!it.icon)
                            : undefined,
                      }
                    )}
                  />

                  <div className="watermarks-container-ghost">
                    {watermarks && watermarks.length
                      ? watermarks.map((mark, index) => {
                          return (
                            <div
                              className="watermarks-container-ghost-item"
                              key={mark.id}
                              style={this.calMarkStyle(mark)}
                              onClick={() =>
                                this.setState({
                                  edit: mark,
                                })
                              }
                            >
                              <img src={`//image1.jfoto.cn/${mark.icon}`} />
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>
              </div>
              <Button.Group style={{ marginTop: 10 }}>
                {watermarks && watermarks.length >= 3 ? null : (
                  <Button onClick={this.insertWatermark.bind(this)}>
                    添加一个水印
                  </Button>
                )}
                <Button onClick={() => this.showBigPic()}>查看大图</Button>
              </Button.Group>
            </div>
            {useReset ? (
              <React.Fragment>
                <Popconfirm
                  overlayStyle={{ zIndex: 1031 }}
                  title="仅当修改水印后才需重置拼图，是否确认继续？"
                  onConfirm={this.props.resetWatermark}
                  okText="继续重置"
                  cancelText="取消"
                >
                  <Button style={{ marginTop: 10 }}>重置拼图</Button>
                </Popconfirm>
                <GuideTip tooltip="直播过程中，若临时更换水印，前端相册的拼图照片，水印并不会同步更换。点击重置拼图，则拼图照片的水印更换为新的" />
              </React.Fragment>
            ) : null}
          </div>
        </div>
        <Modal
          visible={!!edit}
          title={
            <React.Fragment>
              <span>编辑水印</span>
              <Icon
                type="delete"
                style={{ marginLeft: 10, color: "#ffa39e" }}
                onClick={() => {
                  this.deleteWatermark(Object.assign({}, edit));
                  this.setState({
                    edit: null,
                  });
                }}
              />
            </React.Fragment>
          }
          width={340}
          onCancel={() => {
            this.setState({ edit: null });
          }}
          onOk={this.onEditWatermark}
        >
          {edit ? (
            <React.Fragment>
              <Info
                label="位置"
                type="select"
                width={80}
                data={ALIGN_MAP.filter((it) => {
                  if (watermarks && watermarks.length) {
                    if (
                      watermarks.find(
                        (one) => one.align == it.key && one.align != edit.align
                      )
                    ) {
                      return false;
                    }
                  }
                  return true;
                })}
                value={edit.align}
                onChange={this.changeWatermark.bind(this, "align")}
              />
              <Info
                label="高度占比"
                type="number"
                min={1}
                max={400}
                value={edit.percent}
                onChange={this.changeWatermark.bind(this, "percent")}
              />
              <Info
                label="透明度"
                type="number"
                min={0}
                max={100}
                value={edit.opacity}
                onChange={this.changeWatermark.bind(this, "opacity")}
              />
              <Info
                label="无边距"
                type="switch"
                value={edit.noborder}
                onChange={this.changeWatermark.bind(this, "noborder")}
              />
              <Uploader
                className="dp-f a-c"
                uploadFinish={this.changeWatermark.bind(this, "icon")}
                directory="attachment"
              >
                {edit.icon ? (
                  <img
                    src={getPhotoSrc({ photo: edit.icon })}
                    alt="avatar"
                    className="avatar"
                  />
                ) : (
                  <Icon type="plus" className="avatar-uploader-trigger" />
                )}
              </Uploader>
              {edit && edit.icon ? (
                <div style={{ marginTop: 5, fontSize: 12 }}>
                  <a
                    href={`${getPhotoSrc({ photo: edit.icon }, false)}`}
                    download={`watermark.png`}
                    target="_blank"
                  >
                    下载当前水印
                  </a>
                </div>
              ) : null}
            </React.Fragment>
          ) : null}
        </Modal>
      </div>
    );
  }
}

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sync: false,
      order: {},
      expandKeys: [],
      goodList: [],
      mobileOpen: true,
      searchValue: "",
    };

    props.topic.sub("CHILDREN_CHANGE", this.fetchChildren);
    props.topic.sub("CHILDREN_COMPLETE_PLEASE", this.sendGalleryChildren);
    props.topic.sub("GALLERY_CHANGE", this.onOtherChangeGallery);
  }

  componentDidMount() {
    this.fetchChildren().then((res) => {
      let localExpand = window.localStorage.getItem(
        `gallery_last_expand_${this.props.galleryid}`
      );
      try {
        localExpand = JSON.parse(localExpand);
      } catch (e) {}
      this.setState(
        {
          expandKeys:
            localExpand instanceof Array && localExpand.length
              ? localExpand
              : [this.props.galleryid].concat(
                  this.state.children.map((it) => String(it.id))
                ),
        },
        () => {}
      );
    });
    // .then((res)=>{
    // let localLast = window.localStorage.getItem('gallery_last_view_' + this.props.galleryid);
    // debugger;
    // if(localLast && res.find(it=>it.id == localLast)) {
    //   this.onSelect([localLast]);
    // }else {
    //   this.setState({
    //     selected:this.props.galleryid
    //   });
    // }
    // });
  }

  fetchChildren = () => {
    return new Promise((resolve) => {
      return ajaxv2({
        url:
          DOMAIN_CURRENT +
          "/api/v2/gallery/" +
          this.props.galleryid +
          "/childlist",
      }).then((res) => {
        this.setState(
          {
            children: res || [],
          },
          () => {
            resolve();
            console.log(`public children-complete`);
            this.props.topic.pub("CHILDREN_COMPLETE", res);
          }
        );
        return res;
      });
    });
  };

  sendGalleryChildren = () => {
    this.props.topic.pub("CHILDREN_COMPLETE", this.state.children);
  };

  onOtherChangeGallery = (opt) => {
    this.setState({
      selected:
        opt.tag === null
          ? `${opt.galleryid}`
          : `tag_${opt.galleryid}_${opt.tag}`,
    });
  };

  onSelect = (key) => {
    if (key && key.length) {
      this.setState(
        {
          selected: key[0],
        },
        () => {
          if (this.state.selected.indexOf("tag_") == 0) {
            let split = this.state.selected.split("_");
            this.props.topic.pub("GALLERY_CHANGE", {
              tag: split[2],
              galleryid: split[1],
            });
          } else {
            this.props.topic.pub("GALLERY_CHANGE", {
              tag: null,
              galleryid: this.state.selected,
            });
          }
          this.onUpdateExpand();
          window.localStorage.setItem(
            "gallery_last_view_" + this.props.galleryid,
            this.state.selected
          );
        }
      );
    }
  };

  checkGalleryChange = (res) => {
    let { gallery } = this.props;
    let { children } = this.state;

    if (gallery.id == res.id) {
      this.props.topic.pub("GALLERY_EDIT", res);
    } else {
      this.props.topic.pub("GALLERY_CHANGE", {
        tag: "",
        galleryid: res.id,
      });
    }

    (children || []).forEach((it) => {
      if (it.id == res.id) {
        this.fetchChildren();
      }
    });
  };

  editGallery = (gallery, isChildren) => {
    this.setState(
      {
        edit: Object.assign({}, gallery),
        isChildren,
      },
      () => {
        this.fetchOrder();
        if (this.state.edit) {
          if (this.state.edit.is_pay_down && this.state.goodList.length <= 0) {
            this.fetchGoodList();
          }
        }
      }
    );
    preTitle = document.title;
    document.title = currentShowTitle;
  };

  fetchOrder = () => {
    let { edit, order } = this.state;
    let { orderid } = edit;

    if (!order[orderid]) {
      ajax({
        url: "/api/order/" + orderid,
      }).then((res) => {
        order[orderid] = res;
        this.setState({
          order,
        });
      });
    }
  };

  removeGallery = (gallery) => {
    let { edit } = this.state;
    Modal.confirm({
      title: "确定要删除此相册？",
      content: "删除后，相册内照片无法找回，慎重操作",
      onOk: () => {
        if (edit && edit.parent * 1 != 0) {
          ajaxv2({
            url: DOMAIN_CURRENT + "/api/v2/gallery/del/" + edit.id,
            method: "POST",
          }).then((res) => {
            this.setState(
              {
                selected: this.props.galleryid,
                edit: null,
                isChildren: null,
                sync: false,
                syncPrivacy: false,
              },
              () => {
                this.onUpdateExpand();
                window.localStorage.setItem(
                  `gallery_last_view_${this.props.galleryid}`,
                  this.props.galleryid
                );
                this.fetchChildren();
              }
            );
          });
        } else {
          message.error("相册不存在，或者为主相册，不允许被删除");
          return;
        }
      },
    });
  };

  onSubmitEdit = () => {
    let { edit, sync, syncPrivacy } = this.state;

    // 这里要检测一下时间与直播状态的关系
    let { name, start_time, end_time, status } = edit;
    if (!start_time || !moment(start_time).isValid()) {
      message.error("开始时间未填写 或 格式不正确");
      return;
    }
    if (!end_time || !moment(end_time).isValid()) {
      message.error("结束时间未填写 或格式不正确");
      return;
    }
    if (!name) {
      return message.error("相册名称为必填内容");
    }
    if (moment().isAfter(start_time) && moment().isBefore(end_time)) {
      status = "living";
    } else if (moment().isBefore(start_time)) {
      status = "wait";
    } else if (moment().isAfter(end_time)) {
      status = "end";
    }

    edit.status = status;

    ajaxv2({
      url: DOMAIN_CURRENT + "/api/v2/gallery/saveone/" + edit.id,
      method: "POST",
      data: edit,
    }).then((res) => {
      this.checkGalleryChange(res);
      this.setState({
        edit: null,
        isChildren: null,
        watermarkChanged: false,
        sync: false,
        syncPrivacy: false,
      });
    });

    this.syncData(
      {
        watermarks: edit.watermarks,
        privacy: edit.privacy,
        check: edit.check,
      },
      {
        watermarks: sync,
        privacy: syncPrivacy,
        check: syncPrivacy,
      }
    );
  };

  onCancelEdit = () => {
    this.setState({
      edit: null,
      watermarkChanged: false,
      sync: false,
      syncPrivacy: false,
    });
    document.title = preTitle;
  };

  renderTitle = (gallery, isChildren) => {
    let { children } = this.state;
    let tags = [];
    if (gallery && gallery.privacy == "private") {
      tags.push(
        <Tag color="red" key="private">
          私密
        </Tag>
      );
    }
    if (gallery && gallery.check * 1 == 1) {
      tags.push(
        <Tag color="geekblue" key="check">
          审核
        </Tag>
      );
    }
    if (gallery && gallery.is_pay_down * 1 >= 1) {
      tags.push(
        <Tag color="green" key="pay">
          付费
        </Tag>
      );
    }
    return (
      <div className="tree-content" title={gallery.name}>
        <div className="tree-title">
          <div>{byteSubstring(gallery.name || "", 999)}</div>
          {tags && tags.length ? tags : null}
          <div>{formatDateRange(gallery.start_time, gallery.end_time)}</div>
        </div>
        {!window.actionFor("gallery-edit", "boolean") ? (
          <Icon
            onClick={this.editGallery.bind(
              this,
              gallery,
              children && children.length && !isChildren
            )}
            type="edit"
            style={{ marginLeft: 5 }}
          />
        ) : null}
      </div>
    );
  };

  syncData = (data, flags) => {
    let { watermarks, privacy, check } = data;
    flags = flags || {
      privacy: false,
      watermarks: false,
      check: false,
    };

    if (!flags.privacy && !flags.watermarks && !flags.check) {
      return;
    }

    let { gallery } = this.props;
    let { children, edit, isChildren } = this.state;

    let format = [];
    if (gallery) {
      let obj = {
        id: gallery.id,
      };

      if (flags.privacy) {
        obj.privacy = privacy;
      }

      if (flags.watermarks) {
        obj.watermarks = watermarks;
      }

      if (flags.check) {
        obj.check = check;
      }

      format.push(obj);
    }

    (children || []).forEach((it) => {
      let obj = {
        id: it.id,
      };

      if (flags.privacy) {
        obj.privacy = privacy;
      }

      if (flags.watermarks) {
        obj.watermarks = watermarks;
      }

      if (flags.check) {
        obj.check = check;
      }

      format.push(obj);
    });

    ajaxv2({
      url: DOMAIN_CURRENT + "/api/v2/gallery/savemore",
      method: "POST",
      data: format,
    }).then((res) => {
      // this.checkGalleryChange(res);
      message.success("同步设置成功");
    });
  };

  resetWatermark = () => {
    let { dispatch } = this.props;
    let { edit } = this.state;
    if (edit && edit.id) {
      dispatch(AjaxAction.galleryResetWatermark(edit.id)).then((res) => {
        message.success("重置成功");
      });
    }
  };

  checkCanRemoveTag = (name, resolve, reject) => {
    let { dispatch } = this.props;
    let { edit } = this.state;

    dispatch(
      AjaxAction.imageList({
        key: JSON.stringify({
          galleryid: edit.id,
          "tags[~]": name,
        }),
        page: 1,
        pagesize: 1,
      })
    ).then((res) => {
      if (res && res.total * 1) {
        Modal.info({
          title: "删除标签提示",
          content:
            "标签（" +
            name +
            "）下已有照片，此标签删除，照片不会删除。标签删除后重新创建相同名称的标签，照片会自动匹配",
        });
        resolve();
      } else {
        resolve();
      }
    });
  };

  onUpdateExpand = (flag, node) => {
    let result = node
      ? flag
      : this.state.expandKeys.concat(this.state.selected).map(String);
    this.setState(
      {
        expandKeys: unique(result),
      },
      () => {
        window.localStorage.setItem(
          "gallery_last_expand_" + this.props.galleryid,
          JSON.stringify(this.state.expandKeys)
        );
      }
    );
  };

  fetchGoodList = () => {
    const { gallery } = this.props;
    ajaxv2({
      url: "/api/v2/pay/good/list",
      data: {
        gallery_id: gallery.id,
        page: 1,
        page_size: 100,
      },
    }).then((res) => {
      this.setState({
        goodList: res,
      });
    });
  };

  renderCreateNewAlbum = () => {
    const { gallery } = this.props;
    return gallery && !window.actionFor("gallery-create", "boolean") ? (
      <Dropdown
        overlay={
          <Menu onClick={this.createMoreGallery}>
            <Menu.Item key="more">批量创建</Menu.Item>
          </Menu>
        }
      >
        <Button
          type="primary"
          onClick={() => {
            this.setState({
              createGalleryVisible: true,
              createMore: false,
            });
          }}
        >
          新建子相册
          <Icon type="down" />
        </Button>
      </Dropdown>
    ) : null;
  };

  createMoreGallery = (e) => {
    if (e.key === "more") {
      this.setState({
        createGalleryVisible: true,
        createMore: true,
      });
    }
  };

  doAddChildren = (data) => {
    const { tempGalleryName } = data;
    let { tempStartTime, tempEndTime } = data;
    let { gallery, order } = this.props;
    if (tempGalleryName) {
      if (!moment(tempStartTime * 1).isValid()) {
        tempStartTime = moment(order.actionstarttime * 1);
      }
      if (!moment(tempEndTime * 1).isValid()) {
        tempEndTime = moment(order.actionendtime * 1);
      }
      if (tempStartTime && tempEndTime) {
        let promise = null;

        if (tempGalleryName && tempGalleryName.indexOf("审核") > -1) {
          promise = new Promise((resolve) => {
            Modal.confirm({
              title: "是否开启审核相册设置？",
              content:
                "开启后，照片只有在品控链接里审核通过，才会展现在直播页里，才会识别人脸，无需担心未通过照片在相册被检索",
              onOk: () => {
                resolve({
                  check: 1,
                });
              },
              onCancel: () => {
                resolve({});
              },
            });
          });
        } else {
          promise = new Promise((resolve) => resolve({}));
        }

        return new Promise((resolve) => {
          promise.then((property) => {
            return ajaxv2({
              url: `${DOMAIN_CURRENT}/api/v2/gallery/add`,
              method: "post",
              data: {
                name: tempGalleryName,
                orderid: gallery.orderid,
                parent: gallery.id,
                status: "wait",
                start_time: moment(tempStartTime * 1).isValid()
                  ? moment(tempStartTime).format("YYYY-MM-DD HH:mm:ss")
                  : moment(order.actionstarttime * 1).format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                end_time: moment(tempEndTime * 1).isValid()
                  ? moment(tempEndTime).format("YYYY-MM-DD HH:mm:ss")
                  : moment(order.actionendtime * 1).format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                watermark_password: uuid(6, 10),
                ...(property || {}),
              },
            }).then((res) => {
              resolve(res);
              return res;
            });
          });
        });
      } else {
        message.error("开始结束时间为必填");
        return false;
      }
    } else {
      message.error("相册名称为必填");
      return false;
    }
  };

  onConfirmAddChildren = async () => {
    let {
      tempGalleryName,
      tempGalleryList,
      tempStartTime,
      tempEndTime,
      createMore,
    } = this.state;
    let { gallery, topic, order } = this.props;
    if (createMore) {
      let galleryNames = (tempGalleryList || "").split("\n").filter(Boolean);
      if (galleryNames && galleryNames.length) {
        for (let i = 0; i < galleryNames.length; i++) {
          const hide = message.loading(
            `正在创建 (${i + 1}/${galleryNames.length})`
          );
          await this.doAddChildren({
            tempGalleryName: galleryNames[i],
            tempStartTime,
            tempEndTime,
          });
          hide();
        }

        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
        message.success("创建完成");
        this.setState(
          {
            createGalleryVisible: false,
          },
          () => topic.pub("CHILDREN_CHANGE")
        );
      }
    } else {
      let res = await this.doAddChildren({
        tempGalleryName,
        tempStartTime,
        tempEndTime,
      });

      if (res) {
        this.setState(
          {
            current: res,
            createGalleryVisible: false,
          },
          () => topic.pub("CHILDREN_CHANGE")
        );
      }
    }
  };

  render() {
    let { gallery: masterGallery } = this.props;
    let {
      children,
      edit,
      isChildren,
      order,
      goodList,
      mobileOpen,
      searchValue,
    } = this.state;
    const rowCls = classNames(isWeb() ? "dp-f j-c a-c" : "");

    let filteredChildren = children;
    if (searchValue) {
      filteredChildren = (children || []).filter(
        (item) => item.name.indexOf(searchValue) > -1
      );
    }

    return (
      <div className={"filev2-tree " + (mobileOpen ? "open" : "close")}>
        <div className="folder">
          {mobileOpen ? (
            <Icon
              type="left-square"
              onClick={() => {
                this.setState({
                  mobileOpen: false,
                });
              }}
            />
          ) : (
            <Icon
              type="right-square"
              onClick={() => {
                this.setState({
                  mobileOpen: true,
                });
              }}
            />
          )}
        </div>
        {this.renderCreateNewAlbum()}
        <div style={{ padding: "10px 10px 0 10px" }}>
          <Input.Search
            placeholder="请输入相册名称搜索"
            onChange={(e) => this.setState({ searchValue: e.target.value })}
          />
        </div>
        <div style={{ flex: 1, overflowY: "auto" }}>
          {masterGallery ? (
            <Tree
              showLine
              defaultExpandAll={true}
              onSelect={this.onSelect}
              selectedKeys={[this.state.selected]}
              expandedKeys={this.state.expandKeys}
              onExpand={this.onUpdateExpand}
            >
              <TreeNode title={this.renderTitle(masterGallery)} key={masterGallery.id}>
                {filteredChildren &&
                  filteredChildren.map((it) => {
                    return (
                      <TreeNode title={this.renderTitle(it, true)} key={it.id}>
                        {(it.tags || "")
                          .split(",")
                          .filter(Boolean)
                          .map((tag) => {
                            return (
                              <TreeNode
                                title={"标签:" + tag}
                                key={`tag_${it.id}_${tag}`}
                              />
                            );
                          })}

                        {(it.tags || "").split(",").filter(Boolean).length ? (
                          <TreeNode title={"无标签"} key={`tag_${it.id}_`} />
                        ) : null}
                      </TreeNode>
                    );
                  })}
                {children && children.length ? null : (
                  <React.Fragment>
                    {(() => {
                      const masterGalleryTags = (masterGallery.tags || "")
                        .split(",")
                        .filter(Boolean);
                      return (
                        <>
                          {masterGalleryTags.map((tag) => (
                            <TreeNode
                              title={"标签:" + tag}
                              key={`tag_${masterGallery.id}_${tag}`}
                            />
                          ))}
                          {masterGalleryTags.length > 0 && (
                            <TreeNode
                              title={"无标签"}
                              key={`tag_${masterGallery.id}_`}
                            />
                          )}
                        </>
                      );
                    })()}
                  </React.Fragment>
                )}
              </TreeNode>
            </Tree>
          ) : null}
        </div>
        <Modal
          visible={!!edit}
          width={750}
          centered
          title={
            <>
              编辑相册{" "}
              {!isChildren && !!edit && edit.parent * 1 != 0 ? (
                <Icon
                  type="delete"
                  style={{ color: "#ffa39e" }}
                  onClick={this.removeGallery}
                />
              ) : null}
            </>
          }
          onOk={this.onSubmitEdit}
          onCancel={this.onCancelEdit}
        >
          {edit ? (
            <React.Fragment key={edit.id}>
              <div className={rowCls}>
                <Info
                  type="text"
                  value={edit.name}
                  onChange={(newName) => {
                    // const reg = /^[^\/:*?"<>|+]*$/;
                    // if((newName || "").match(reg)) {
                    let { edit } = this.state;
                    edit.name = newName;
                    this.setState({
                      edit,
                    });
                    // }else {
                    //   message.error('相册名称不能包含以下任意字符：\\ / : * ? " < > | +');
                    // }
                  }}
                  label="相册名称"
                  required
                />
                <Info
                  type="text"
                  value={order[edit.orderid] && order[edit.orderid].name}
                  isText={true}
                  label="所属订单"
                />
              </div>
              <div className={rowCls}>
                <Info
                  type="datetime"
                  required
                  value={
                    moment(edit.start_time).isValid()
                      ? moment(edit.start_time)
                      : null
                  }
                  onChange={(e) => {
                    let { edit } = this.state;
                    if (e) {
                      edit.start_time = e.format("YYYY-MM-DD HH:mm:ss");
                      this.setState({
                        edit,
                      });
                    }
                  }}
                  label="开始时间"
                  tooltip="默认订单活动时间，修改会影响相册直播状态，同时会影响海报功能里显示的活动时间"
                />
                <Info
                  type="datetime"
                  requried
                  value={
                    moment(edit.end_time).isValid()
                      ? moment(edit.end_time)
                      : null
                  }
                  onChange={(e) => {
                    let { edit } = this.state;
                    if (e) {
                      edit.end_time = e.format("YYYY-MM-DD HH:mm:ss");
                      this.setState({
                        edit,
                      });
                    }
                  }}
                  label="结束时间"
                  tooltip="默认订单活动时间，修改会影响相册直播状态，同时会影响海报功能里显示的活动时间"
                />
              </div>
              <div className={rowCls} style={{ width: 300 }}>
                <Info
                  maxLength={6}
                  placeholder="6位纯数字密码"
                  type="text"
                  label="无水印密码"
                  value={edit.watermark_password}
                  tooltip="无水印相册的管理密码，可在装修界面里复制管理链接，该密码为随机6位数字，可修改"
                  addonAfter={
                    <span
                      onClick={() => {
                        let e = uuid(6, 10);
                        let { edit } = this.state;
                        edit.watermark_password = e;
                        this.setState({
                          edit,
                        });
                      }}
                    >
                      随机
                    </span>
                  }
                  onChange={(e) => {
                    e = e.replace(/[^0-9]/gi, "");
                    let { edit } = this.state;
                    edit.watermark_password = e;
                    this.setState({
                      edit,
                    });
                  }}
                />
              </div>
              <div className={rowCls}>
                <Info
                  type="text"
                  isText={true}
                  className={isWeb() ? "" : "mobile"}
                  label="相册隐私设置"
                  value={
                    <div className="custom-config-form">
                      {isChildren ? null : (
                        <Info
                          type="switch"
                          value={edit.privacy == "private" ? 1 : 0}
                          label="私密相册"
                          onChange={(e) => {
                            let { edit } = this.state;
                            edit.privacy = !!e * 1 ? "private" : "normal";
                            this.setState({
                              edit,
                            });
                          }}
                          tooltip={`为保证私密性，私密相册的照片，仅能在本相册内通过人脸检索。在其他相册通过本人或关注的人等跨相册识别方式无法获取。`}
                        />
                      )}
                      {isChildren ? null : (
                        <Info
                          type="switch"
                          value={edit.check * 1 ? 1 : 0}
                          label="审核相册"
                          onChange={(e) => {
                            let { edit } = this.state;
                            edit.check = !!e * 1 ? 1 : 0;
                            this.setState({
                              edit,
                            });
                          }}
                          tooltip="审核相册的照片，只有选择通过后，才会识别人脸，无需担心未通过照片在相册被检索到。"
                        />
                      )}
                      {isChildren ? null : (
                        <Info
                          type="switch"
                          value={this.state.syncPrivacy}
                          label={
                            <span>
                              同步隐私设置
                              <br />
                              至其它相册
                            </span>
                          }
                          onChange={(e) => {
                            this.setState({
                              syncPrivacy: e,
                            });
                          }}
                        />
                      )}
                    </div>
                  }
                />
              </div>
              {isChildren ? null : (
                <Info
                  type="select"
                  value={String(edit.is_pay_down)}
                  label="付费商品"
                  data={[{ key: "0", name: "无" }].concat(
                    (goodList || []).map((it) => {
                      return {
                        key: String(it.id),
                        name: it.name,
                      };
                    })
                  )}
                  onChange={(e) => {
                    this.setState({
                      edit: {
                        ...edit,
                        is_pay_down: Number(e),
                      },
                    });
                  }}
                  width={320}
                  rightElement={
                    <div>
                      <a
                        target={`good_${masterGallery.id}`}
                        href={`/page/pay/good/${masterGallery.id}`}
                      >
                        前往商品管理
                      </a>
                      <a
                        style={{ marginLeft: 10 }}
                        onClick={this.fetchGoodList}
                      >
                        刷新
                      </a>
                    </div>
                  }
                />
              )}
              {isChildren ? null : (
                <Info
                  type="movetag"
                  value={(edit.tags || "").split(",").filter(Boolean)}
                  onChange={(e) => {
                    let { edit } = this.state;
                    edit.tags = e;
                    this.setState({
                      edit,
                    });
                  }}
                  label="相册标签"
                  staticTag={["全部", "热门", "人物"]}
                  onRemove={this.checkCanRemoveTag}
                  style={{ alignItems: isWeb() ? "center" : "flex-start" }}
                  pattern={/^[^+][^\/:*?"<>|]*$/}
                  addTooltip
                  tooltip="鼠标拖动标签可排序"
                />
              )}
              {isChildren ? null : (
                <React.Fragment>
                  {/*<Watermarks watermarks={JSON.parse(edit.watermarks)} onChange={e=>{
                        let {edit} = this.state;
                        edit.watermarks = JSON.stringify(e);
                        this.setState({
                            edit,
                            watermarkChanged:true
                        });
                      }} resetWatermark={this.resetWatermark} />*/}
                  <WatermarksV2
                    key={edit ? edit.id : 0}
                    id={edit ? edit.id : 0}
                    value={JSON.parse(edit.watermarks)}
                    onChange={(e) => {
                      let { edit } = this.state;
                      edit.watermarks = JSON.stringify(e);
                      this.setState({
                        edit: {
                          ...edit,
                        },
                        watermarkChanged: true,
                      });
                    }}
                    resetWatermark={this.resetWatermark}
                  />
                </React.Fragment>
              )}
              {isChildren ? null : this.state.watermarkChanged ? (
                <Info
                  type="switch"
                  label={
                    <span>
                      同步水印
                      <br />
                      至所有相册
                    </span>
                  }
                  value={!!this.state.sync}
                  onChange={(e) => {
                    this.setState({
                      sync: e,
                    });
                  }}
                  tooltip="选择开启后，则本订单内所有相册均使用这个水印"
                />
              ) : null}
            </React.Fragment>
          ) : null}
        </Modal>

        <Modal
          visible={this.state.createGalleryVisible}
          title={`${this.state.createMore ? "批量" : ""}新建子相册`}
          centered={true}
          maskClosable={false}
          onOk={this.onConfirmAddChildren}
          onCancel={() => {
            this.setState({
              createGalleryVisible: false,
            });
          }}
          okText="确认"
          cancelText="取消"
          width={750}
        >
          {this.state.createMore ? (
            <Info
              type="textarea"
              label="相册名称"
              tooltip="批量创建相册，每行一个，换行新增"
              placeholder="一行一个相册，新增相册请换行"
              value={this.state.tempGalleryList}
              onChange={(newName) => {
                // const reg = /^[^\/:*?"<>|+]*$/;
                // if((newName || "").match(reg)) {
                this.setState({ tempGalleryList: newName });
                // }else {
                //   message.error('相册名称不能包含以下任意字符：\\ / : * ? " < > | +');
                // }
              }}
              width={320}
            />
          ) : (
            <Info
              type="text"
              label="相册名称"
              value={this.state.tempGalleryName}
              onChange={(newName) => {
                // const reg = /^[^\/:*?"<>|+]*$/;
                // if((newName || "").match(reg)) {
                this.setState({ tempGalleryName: newName });
                // }else {
                //   message.error('相册名称不能包含以下任意字符：\\ / : * ? " < > | +');
                // }
              }}
            />
          )}
          <Info
            type="datetime"
            required
            label="开始时间"
            value={this.state.tempStartTime}
            onChange={(e) => {
              this.setState({ tempStartTime: e });
            }}
            tooltip="默认订单活动时间，修改会影响相册直播状态，同时会影响海报功能里显示的活动时间"
          />
          <Info
            type="datetime"
            required
            label="结束时间"
            value={this.state.tempEndTime}
            onChange={(e) => {
              this.setState({ tempEndTime: e });
            }}
            tooltip="默认订单活动时间，修改会影响相册直播状态，同时会影响海报功能里显示的活动时间"
          />
          {/* {this.state.createMore ? <div  className={rowCls} style={{width:300}}>
                <Info maxLength={6} placeholder="6位纯数字密码" type="text" label="无水印密码"
                  value={this.state.tempGalleryPassword}
                  tooltip="无水印相册的管理密码，可在装修界面里复制管理链接，该密码为随机6位数字，可修改"
                  addonAfter={<span onClick={()=>{
                    let e = uuid(6, 10);
                    this.setState({
                      tempGalleryPassword:e
                    });
                  }}>随机</span>}
                  onChange={(e)=>{
                    e = e.replace(/[^0-9]/ig, '');
                    this.setState({
                      tempGalleryPassword:e
                    });
                  }}
                />
              </div> : null}
              {this.state.createMore ? <Info type="movetag" value={(this.state.tempGalleryTags || "").split(',').filter(Boolean)} onChange={(e)=>{
                this.setState({
                    tempGalleryTags:e
                });
              }} label="相册标签" staticTag={['全部', '热门', '人物']} onRemove={this.checkCanRemoveTag}
                style={{alignItems:isWeb()?'center':'flex-start'}}
                pattern={/^[^+][^\/:*?"<>|]*$/}
                addTooltip
                tooltip="鼠标拖动标签可排序"
              /> : null} */}
        </Modal>
      </div>
    );
  }
}

export default connect()(Index);



// WEBPACK FOOTER //
// ./src/components/FileViewerV2/page/tree/index.js